<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="page-title-section">
    <h2>Assurance Voyage - Assistance - Rapatriement du Professionnelle</h2>
  </div>

  <div class="main-content">
    <p>
      L'assurance voyage professionnelle assure déplacement professionnel à l'étranger qui s'oppose au séjour réalisé à titre privé, puisqu'il a une finalité liée à votre activité professionnelle : votre salarié quitte la France pour une certaine durée dans l'intérêt dans votre intérêt ou dans le cadre de votre métier si vous exercez une profession libérale. Il peut s'agir d'un départ volontaire du salarié ou du professionnel.
    </p>
    <p>
      Un déplacement professionnel (ou voyage d'affaires) s'entend également comme une mission à l'étranger de moins de <strong class="highlight-purple">90 jours consécutifs</strong>, et de moins de <strong class="highlight-purple">180 jours au total par an</strong>. Si le salarié ou le professionnel dépasse cette limite, le statut sera différent : vous serez considéré comme un expatrié partant « en détachement ». Il vous faudra donc une assurance voyage expatrié. La terminologie est importante car les obligations légales de l'employeur diffèrent selon la durée de séjour à l'étranger de ses collaborateurs.
    </p>
    <p>
      Tous les types de statuts sont concernés et peuvent partir en mission à l'étranger : salariés, employés de PME / TPE, professions libérales, corps diplomatique, stagiaires… Cependant, certaines professions ou certaines positions dans l'entreprise sont plus susceptibles d'être missionnés hors de nos frontières comme les commerciaux, les top managers, les consultants ou encore les ingénieurs spécialisés.
    </p>
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, APRIL, SWISSLIFE, ALPTIS, HENNER, CHAPKA…</strong>
    </p>

    <div class="content-section">
      <h3>Quelle est la différence entre voyageur d'affaires et expatrié ?</h3>
      <p>
        La distinction entre voyage d'affaire (ou mission professionnelle) et expatriation doit être faite car les obligations légales de l'employeur ne sont pas les mêmes. Les expatriés partant en détachement sont amenés à rester plus longtemps, ils bénéficient donc d'une protection plus large qui s'étend le cas échéant à leur famille. Sur le plan de l'assurance, les professionnels partant en mission courte ont un besoin de protection contre les risques « d'urgence » (accident, maladie, rapatriement…). Les expatriés ont, quant à eux, droit à une couverture plus complète et « quotidienne », relative à leur nouvelle vie sur place.
      </p>
      <p>
        La différenciation repose sur le critère de la durée de votre présence hors France :
      </p>
      <ul>
        <li>Si vous partez moins de <strong class="highlight-purple">90 jours consécutifs</strong> et au total, moins de <strong class="highlight-purple">180 jours par an</strong>, vous êtes un voyageur d'affaires,</li>
        <li>Si vous partez plus de <strong class="highlight-purple">180 jours consécutifs</strong> ou pour un détachement permanent (sans date de retour fixée), vous êtes un expatrié, vous aurez besoin d'une couverture plus solide notamment avec prise en charge des frais de santé. En effet, vos droits à la sécurité sociale s'arrêtent au bout de <strong class="highlight-purple">90 jours</strong>. Il est donc nécessaire de souscrire une assurance Mutuelle Santé Internationale Professionnelle.</li>
      </ul>
      <p>
        Si vous envoyez un de vos salariés en expatriation et que sa famille l'accompagne à l'étranger, vous devrez prendre sa couverture en charge, en l'incluant dans une police d'assurance voyage professionnelle. D'ailleurs, vous pouvez au choix souscrire un contrat "groupe" ou un contrat individuel.
      </p>
      <p>
        L'objectif d'une telle police d'assurance voyage est de protéger le ou les salariés / le professionnel en cas de situation d'urgence ou d'imprévu venant gâcher leur présence sur place et faisant obstacle à la bonne exécution de leurs responsabilités.
      </p>
      <p>
        L'assurance voyage professionnel à deux volets :
      </p>
      <ul>
        <li>Le volet assurance, c'est-à-dire l'indemnisation, par votre assureur, des frais engagés à l'étranger en cas, par exemple, d'accident ou de maladie,</li>
        <li>Le volet assistance. L'assistance en assurance voyage, c'est l'aide / l'accompagnement de votre assureur lorsque le/les salariés/ le professionnel sont dans une situation compliquée hors de France : vol de vos bagages, perte de vos papiers d'identité, besoin de médicaments… .</li>
      </ul>
      <p>
        L'assurance voyage professionnel couvre pendant toute la durée de leur présence sur place et, même si elle concerne les voyages d'affaires, la plupart des polices étendent la garantie pendant une certaine durée au-delà de leur date de retour initiale, au cas où ils conserveraient le séjour pour des raisons personnelles (tourisme, vacances…). Ils resteraient donc protégés par la même police, sans avoir à souscrire une nouvelle à titre privé depuis l'étranger.
      </p>
      <p>
        Concernant les personnes assurées, il s'agit des collaborateurs envoyés en mission mais aussi de leurs familles les accompagnants.
      </p>
      <p>
        A noter que l'assurance voyage professionnel fonctionne également pour les déplacements réalisés en France.
      </p>
    </div>

    <div class="content-section">
      <h3>Les garanties dans le contrat ?</h3>
      <p>
        Il existe généralement 2 ou 3 formules possibles pour l'assurance voyage, avec généralement :
      </p>
      <p><strong class="text-purple">Garantie Annulation pour toutes causes justifiées :</strong></p>
      <ul>
        <li>Annulation du voyage,</li>
        <li>Vol manqué.</li>
      </ul>
      <p><strong class="text-purple">Garantie Multirisque pour assurer aussi les frais de santé, perte de vos bagages, attestation pour le visa :</strong></p>
      <ul>
        <li>Annulation du voyage,</li>
        <li>Vol manqué,</li>
        <li>Retard aérien > 4 heures,</li>
        <li>Bagages et effets personnels,</li>
        <li>Frais d'interruption de séjour,</li>
        <li>Voyage accidenté individuel,</li>
        <li>Responsabilité civile vie privée à l'étranger,</li>
        <li>Retour impossible,</li>
        <li>Assistance rapatriement,</li>
        <li>Retour anticipé,</li>
        <li>Voyage d'assistance.</li>
      </ul>
      <p>
        Et pour les sportifs, possibilité d'une extension des frais de recherche et de secours en mer et en montagne.
      </p>
      <p>
        La formule complète Multirisque qui regroupe plusieurs garanties (Annulation, Assistance, Santé, Dommages aux biens, Prévoyance) coûte relativement peu chère.
      </p>
      <p>
        Détail a important, il est rarement possible d'assurer son voyage avec la garantie annulation de billet d'avion , si le départ est dans <strong class="highlight-purple">1 semaine</strong>. Il faut toujours prendre son assurance annulation en même temps que son billet ou quelques heures après.
      </p>
      <p>
        Enfin, sachez que l'assurance incluse dans votre carte bleu ne fonctionne que si vous n'avez pas encore pris le vol Aller. Et d'ailleurs, même dans ce cas, les conditions de prise en charge de votre billet par cette assurance sont très limitées.
      </p>
      <p>
        Lorsque vous avez utilisé le billet Aller , et que vous ferez ensuite jouer votre assurance carte bleu pour annuler ou décaler le billet Retour, cela n'est pas possible. Seule la garantie assistance pourrait vous aider, mais dans ce cas, il faut que l'assistance soit sollicitée (Accident, décès, maladie grave).
      </p>
      <p>
        Par ailleurs, ce contrat ne prend pas en charge les frais de santé, comme une mutuelle santé. Au bout de <strong class="highlight-purple">3 mois</strong> à l'étranger la sécurité sociale ne marche plus. Vous perdez vos droits et ceux de la mutuelle. En terme de couverture santé à l'internationale, pour les expatriés (séjour de plus de <strong class="highlight-purple">6 mois consécutifs</strong>), sachez que la couverture de cette assurance voyage prévoie essentiellement du rapatriement sanitaire avec une avance sur les frais d'hospitalisation, pas de prise en charge. L'expatrié peut donc au choix souscrire via son employeur une assurance Mutuelle Santé Internationale en France, pour se faire rembourser ses soins médicaux, ou alors souscrire à la sécurité sociale des français de l'étranger (CFE). Ou alors une combinaison des deux. Il peut aussi souscrire une mutuelle locale.
      </p>
    </div>

    <div class="content-section">
      <div class="highlight-box">
        <p>
          <strong class="highlight-purple">60 %</strong> des Français partent en vacances mais seulement <strong class="highlight-purple">35 %</strong> souscrivent à une assurance voyage !
        </p>
      </div>
      <p>
        La plupart des Français ne savent pas qu'ils peuvent être assurés en cas d'annulation de leur prestation ou en cas d'accident sur place. Ou, cela arrive plus souvent qu'on ne le croit.
      </p>
      <p>
        A chaque besoin une formule d'assurance vous correspond, il vous suffit de vous poser les bonnes questions :
      </p>
      <ul>
        <li>Avez-vous besoin d'une attestation pour la Russie ?</li>
        <li>Quels sont les montants des frais médicaux conseillés pour partir aux Etats-Unis ou en Asie ?</li>
        <li>Et si vous manquez votre vol ?</li>
        <li>Etes-vous assuré en cas d'accident durant une compétition sportive ?</li>
      </ul>
      <p>
        <strong>Attention :</strong> L'assurance comprise dans votre Carte Bancaire ne suffit pas toujours à être bien assuré.
      </p>
      <p>
        <strong>Exemple :</strong> Votre CB, autant vous pouvez garantir l'annulation du Vol allée, autant le vol retour n'est jamais pris en charge.
      </p>
    </div>

    <div class="content-section">
      <h3>LES PLUS :</h3>
      <ul>
        <li>Annulation pour toutes causes justifiées,</li>
        <li>Annulation en cas d'attentat ou de catastrophe naturelle,</li>
        <li>Avion manqué,</li>
        <li>Garantie Retour impossible incluse,</li>
        <li>Une couverture étendue et adaptée pour les déplacements sportifs ou à thème,</li>
        <li>La possibilité de mettre jusqu'à <strong class="highlight-purple">9 personnes</strong> par contrat.</li>
      </ul>
    </div>

    <div class="content-section">
      <h3>IMPORTANT :</h3>
      <ul>
        <li>Le contrat doit être souscrit au plus tard la veille du départ,</li>
        <li>L'extension Sports et Loisirs doit être souscrite simultanément à la Multirisque,</li>
        <li>Sur un même contrat, tous les assurés (salariés) doivent avoir souscrit la même formule,</li>
        <li><strong>Visa :</strong> Pour les voyages en Russie, Biélorussie et Ukraine, une attestation d'assurance originale est nécessaire pour l'obtention du visa.</li>
      </ul>
    </div>
  </div>

<div class="contact-button-wrapper">
  <button class="btn-contact" (click)="navigateToContact()">Contactez-nous</button>
</div>
</app-page-layout>
